var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-container"},[_c('div',{class:[
      'switch-button-container',
      _vm.switchState === 'on' ? 'on-state' : 'off-state'
    ],on:{"click":function($event){return _vm.changeState()}}},[_c('div',{staticClass:"switch-circle-button"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }